function Frontside() {
  return (
    <div className="dice-face face--frontside">
      <span>FRONT</span>
      <span>SIDE</span>
    </div>
  );
}

export default Frontside;
